import { ApiCallState } from "../Utils";
import { Material } from "../Material/Material.type";
import { Store } from "../Store/Store.type";

export const MaterialStartingBalanceActionTypes = {
  FETCH_ALL_MATERIAL_STARTING_BALANCE:
    "FETCH_ALL_MATERIAL_STARTING_BALANCE",
  FETCH_ALL_MATERIAL_STARTING_BALANCE_SUCCESS:
    "FETCH_ALL_MATERIAL_STARTING_BALANCE_SUCCESS",
  FETCH_ALL_MATERIAL_STARTING_BALANCE_FAILURE:
    "FETCH_ALL_MATERIAL_STARTING_BALANCE_FAILURE",
  FETCH_ALL_MATERIAL_STARTING_BALANCE_RESET:
    "FETCH_ALL_MATERIAL_STARTING_BALANCE_RESET",

  BULK_UPSERT_MATERIAL_STARTING_BALANCE:
    "BULK_UPSERT_MATERIAL_STARTING_BALANCE",
  BULK_UPSERT_MATERIAL_STARTING_BALANCE_SUCCESS:
    "BULK_UPSERT_MATERIAL_STARTING_BALANCE_SUCCESS",
  BULK_UPSERT_MATERIAL_STARTING_BALANCE_FAILURE:
    "BULK_UPSERT_MATERIAL_STARTING_BALANCE_FAILURE",
  BULK_UPSERT_MATERIAL_STARTING_BALANCE_RESET:
    "BULK_UPSERT_MATERIAL_STARTING_BALANCE_RESET",
};

export type MaterialStartingBalance = {
  id?: number;
  user_id?: number;
  material_id: number;
  store_id: number;
  starting_balance: number | null;
  date: string;
  material?: Material;
  store?: Store;
  createdAt?: string;
  updatedAt?: string;
};

export type MaterialStartingBalanceStateTypes = {
  fetchAll: ApiCallState<MaterialStartingBalance[]>;
  bulkUpsert: ApiCallState<any>;
};
